import {
  useOneChanceReducer,
  OneChanceContext,
  OneChanceDispatchContext,
} from "app/one-chance/useOneChance";
import { STORAGE_KEY_PREFIX } from "app/utils/useResetableStorage";

interface OneChanceProviderProps {
  roundIndex: number;
  children: React.ReactNode;
}

export function OneChanceProvider(props: OneChanceProviderProps) {
  const [roundState, dispatch] = useOneChanceReducer(
    `${STORAGE_KEY_PREFIX}_ONE_CHANCE_ROUND_STATE_${props.roundIndex}`,
  );
  return (
    <OneChanceContext value={roundState}>
      <OneChanceDispatchContext value={dispatch}>
        {props.children}
      </OneChanceDispatchContext>
    </OneChanceContext>
  );
}
